<template>
    <ContentComponent />
</template>

<script lang="js">
    import ContentComponent from '@/components/AchievementsPage/ContentComponent'

    export default {
        name: "Achievements",
        components: {
            ContentComponent
        }
    }
</script>

<style scoped>

</style>
